import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Icon, Text } from 'components/ui';
import { colors, fontSizes, space } from 'style/config';
import Location from 'utils/Location';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FulfillmentSummaryEN from 'components/Catalog/ProductGrid/ProductTile/FulfillmentSummary/locales/FulfillmentSummary_en_US.js';
import FulfillmentSummaryFR from 'components/Catalog/ProductGrid/ProductTile/FulfillmentSummary/locales/FulfillmentSummary_fr_CA.js';
import {
    PICKUP, SAME_DAY, SHIP_TO_HOME, UPPER_FUNNEL_REFINEMENTS
} from 'constants/UpperFunnel';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;

const FulfillmentSummary = ({
    showFulfillmentMethodOptimizationPLP,
    pickupEligible,
    sameDayEligible,
    shipToHomeEligible,
    checkedRefinements = []
}) => {
    const isPLPOrBrandPage = Location.isRootCategoryPage() || Location.isNthCategoryPage() || Location.isBrandNthCategoryPage();

    if (!isPLPOrBrandPage) {
        return null;
    }

    const getText = getLocalisedDataFromResource(FulfillmentSummaryEN, FulfillmentSummaryFR);
    const inStoreText = getText('inStore');
    const sameDayDeliveryText = getText('sameDayDelivery');
    const shippingText = getText('shipping');

    const activeDeliveryFilters = UPPER_FUNNEL_REFINEMENTS.filter(filter => checkedRefinements.some(refinement => refinement.includes(filter)));

    // Maps each fulfillment method to its active filter key, product eligibility flag, and display text.
    const methodEntries = [
        { filter: PICKUP, eligible: pickupEligible, text: inStoreText },
        { filter: SAME_DAY, eligible: sameDayEligible, text: sameDayDeliveryText },
        { filter: SHIP_TO_HOME, eligible: shipToHomeEligible, text: shippingText }
    ];

    // When a delivery filter is active, show only the matching method(s) — not all eligible ones.
    const fulfillmentMethods = methodEntries
        .filter(({ filter, eligible }) => eligible && (!activeDeliveryFilters.length || activeDeliveryFilters.includes(filter)))
        .map(({ text }) => text);

    if (fulfillmentMethods.length === 0) {
        return null;
    }

    const challengerTwo = showFulfillmentMethodOptimizationPLP.challengerTwo;

    return (
        <Flex
            css={styles.container}
            alignItems='flex-start'
            gap={1}
        >
            <Icon
                name='checkmark'
                size={fontSizes.base}
                color={challengerTwo ? colors.green : colors.gray}
            />
            <Text
                fontSize='xs'
                color={challengerTwo ? null : colors.gray}
                children={fulfillmentMethods.join(', ')}
            />
        </Flex>
    );
};

const styles = {
    container: {
        marginTop: `${space[2]}px`
    }
};

FulfillmentSummary.propTypes = {
    showFulfillmentMethodOptimizationPLP: PropTypes.shape({
        challengerOne: PropTypes.bool,
        challengerTwo: PropTypes.bool
    }).isRequired,
    pickupEligible: PropTypes.bool,
    sameDayEligible: PropTypes.bool,
    shipToHomeEligible: PropTypes.bool,
    checkedRefinements: PropTypes.arrayOf(PropTypes.string)
};

export default wrapFunctionalComponent(FulfillmentSummary, 'FulfillmentSummary');
